import { render, staticRenderFns } from "./to-c.vue?vue&type=template&id=822e642a&scoped=true"
import script from "./to-c.vue?vue&type=script&lang=js"
export * from "./to-c.vue?vue&type=script&lang=js"
import style0 from "./to-c.vue?vue&type=style&index=0&id=822e642a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822e642a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/header/login/to-c.vue
// module id = null
// module chunks = 